import {t} from "../i18n.js";
/*jshint esversion: 11 */

export function parseInstallmentPricing(rawValue) {
    if (!rawValue) {
        return {};
    }

    try {
        const parsed = JSON.parse(rawValue);

        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
            return {};
        }

        return Object.entries(parsed).reduce((carry, [key, value]) => {
            const installments = Number.parseInt(key, 10);
            const percentage = Number.parseFloat(value);

            if (Number.isFinite(installments) && installments > 0 && Number.isFinite(percentage) && percentage >= 0) {
                carry[String(installments)] = percentage;
            }

            return carry;
        }, {});
    } catch (error) {
        console.error("Falha ao interpretar regras de juros de parcelamento:", error);
        return {};
    }
}

export function formatCurrency(value) {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value);
}

export function calculateSurchargeAmount(baseAmount, pricingRules, installments) {
    const percentage = Number.parseFloat(pricingRules?.[String(installments)] ?? 0);

    if (!Number.isFinite(percentage) || percentage <= 0) {
        return 0;
    }

    return Math.round(baseAmount * (percentage / 100) * 100) / 100;
}

// extraAmount: taxa de processamento do método (TEMN-618), somada ao total sem entrar na base dos juros.
export function calculateTotalAmountWithSurcharge(baseAmount, pricingRules, installments, extraAmount = 0) {
    return Math.round((baseAmount + calculateSurchargeAmount(baseAmount, pricingRules, installments) + extraAmount) * 100) / 100;
}

export function buildInstallmentLabel(amount, count) {
    const installmentAmount = Math.round((amount / count) * 100) / 100;

    if (count === 1) {
        return t("1x de :amount", {amount: formatCurrency(amount)});
    }

    return t(":countx de :installment (:total)", {count, installment: formatCurrency(installmentAmount), total: formatCurrency(amount)});
}
